import { Logo, Text, Wrapper } from "./AvailableIntegrationCardHeader.style";

type AvailableIntegrationCardHeaderProps = {
  image: string;
  text: string;
  invertLogo?: boolean;
};

export const AvailableIntegrationCardHeader = (props: AvailableIntegrationCardHeaderProps) => {
  const { image, text, invertLogo } = props;

  return (
    <Wrapper>
      <Logo data-testid="up-tool-logo" logo={image} invert={invertLogo} />
      <Text>{text}</Text>
    </Wrapper>
  );
};
